/* __next_internal_client_entry_do_not_use__ IntlProviderForSSR_Base auto */ import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { jsx as _jsx } from "react/jsx-runtime";
import { localeStringToLocaleKey } from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { IntlProvider } from "@faire/web--source/common/localization/IntlProvider";
import { getTranslationLocale } from "@faire/web--source/common/rsc/localization/utils";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import React from "react";
export var IntlProviderForSSR_Base = function(param) {
    var children = param.children, locale = param.locale;
    if (!isWindowUndefined()) {
        return children;
    }
    var localizationLocale = getTranslationLocale(locale);
    var localeKey = localeStringToLocaleKey(localizationLocale);
    var GLOBAL_INTL_MAP = (typeof globalThis === "undefined" ? "undefined" : _type_of(globalThis)) === "object" && globalThis.GLOBAL_INTL_MAP;
    if (!GLOBAL_INTL_MAP) {
        throw new Error("GLOBAL_INTL_MAP is not defined");
    }
    return /*#__PURE__*/ _jsx(IntlProvider, {
        localeKey: localeKey,
        messages: GLOBAL_INTL_MAP[localizationLocale].messages,
        children: children
    });
};
